import React, { useState, useEffect, useRef } from "react";
import _, { property } from "lodash";
import { v4 as uuid } from "uuid";
import Draggable from "react-draggable";

import { CA_GEO_HIERARCHY_ELEMENTS, CA_RECOMMENDATION_ELEMENTS } from "../constants";
import Portal from "../../common/components/Portal";
import { CAColumnConfigModal } from "./CaBand/ColumnConfigModal";
import { showAlert } from "../../../config/utils";
import actions from "../actions";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect, { components } from "react-select";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import dashboardActions from "../../dashboard/actions";
import CAColumnConfigModalStepper from "./CaBand/ColumnConfigStepper";
import AdditionalExportOptionsModal from "./AdditionalExportOptionsModal";

const AddCAbandModal = ({
    onCancel,
    setSmartChartData,
    entity,
    getCAbandFilterDropDownData,
    getCAbandTradeFilterDropDownData,
    getCAbandDropdownData = [],
    getCAbandTradeDropdownData = [],
    entityMfilters = {},
    currentData = {},
    selectedConfig = null,
    getCAbandSystemFilterDropDownData,
    getCAbandSystemDropdownData = [],
    selectedClient,
    selectedProject,
    isExcelExport = false,
    mfilter = {},
    viewOnly = false,
    selectedExportProperty = ""
}) => {
    const dispatch = useDispatch();
    const initialFormSnapshot = useRef(null);
    const { getDefaultYearBreakdownResponse } = useSelector(state => state.smartChartReducer);
    const [selectedElements, setSelectedElements] = useState(() => {
        if (currentData?.[selectedConfig?.chartKey]?.year_break_down) {
            return {
                line: selectedConfig?.chartKey ? selectedConfig.chartKey.split("_")?.slice(0, -2)?.join(",")?.split(",")?.filter(Boolean) : [],
                column: selectedConfig?.chartKey ? selectedConfig.chartKey.split("_")?.slice(0, -2)?.join(",")?.split(",")?.filter(Boolean) : []
            };
        } else {
            return {
                line: selectedConfig?.chartKey
                    ? (() => {
                          const parts = selectedConfig?.chartKey ? selectedConfig.chartKey.split("_")?.slice(0, -2) : [];
                          const index = parts.indexOf("fci");

                          return parts
                              ?.map((part, i) => {
                                  if (i === index && parts[i + 1] === "benchmarking") {
                                      return "fci_benchmarking";
                                  }
                                  return part;
                              })
                              .filter((part, i, arr) => !(arr[i - 1] === "fci_benchmarking" && part === "benchmarking"));
                      })()
                    : [],
                column: selectedConfig?.chartKey ? selectedConfig.chartKey.split("_")?.slice(-2, -1)[0]?.split(",")?.filter(Boolean) : []
            };
        }
    });
    const [showErrorBorder, setShowErrorBorder] = useState(false);
    const [showDropDown, setShowDropDown] = useState(false);
    const [selectedFilterValues, setSelectedFilterValues] = useState([]);
    const [selectedFilterName, setSelectedFilterName] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [filterLabel, setFilterLabel] = useState(null);
    const initialElements = useRef("");
    const ignoreNextSelectMenuClose = useRef(false);
    const [isSwitchBandActive, setIsSwitchBandActive] = useState(selectedConfig?.chartKey ? false : true);
    const [showTradeDropDown, setShowTradeDropDown] = useState(false);
    const [searchValueTrade, setSearchValueTrade] = useState("");
    const [selectedFilterValuesTrade, setSelectedFilterValuesTrade] = useState(
        (selectedConfig?.chartKey?.includes("system") ||
            selectedConfig?.chartKey?.includes("subsystem") ||
            selectedConfig?.chartKey?.includes("trade")) &&
            currentData[selectedConfig.chartKey]?.trade_ids?.length
            ? [...currentData[selectedConfig.chartKey]?.trade_ids]
            : []
    );
    const [selectedFilterTrade, setSelectedFilterTrade] = useState(
        (selectedConfig?.chartKey?.includes("system") ||
            selectedConfig?.chartKey?.includes("subsystem") ||
            selectedConfig?.chartKey?.includes("trade")) &&
            currentData[selectedConfig.chartKey]?.config_filter_names?.CA_BandFilter?.Trade?.length
            ? [...currentData[selectedConfig.chartKey]?.config_filter_names?.CA_BandFilter?.Trade]
            : []
    );
    const [showSystemDropDown, setShowSystemDropDown] = useState(false);
    const [searchValueSystem, setSearchValueSystem] = useState("");
    const [selectedFilterValuesSystem, setSelectedFilterValuesSystem] = useState(
        selectedConfig?.chartKey?.includes("subsystem") && currentData[selectedConfig.chartKey]?.system_ids?.length
            ? [...currentData[selectedConfig.chartKey]?.system_ids]
            : []
    );
    const [selectedFilterSystem, setSelectedFilterSystem] = useState(
        selectedConfig?.chartKey?.includes("subsystem") && currentData[selectedConfig.chartKey]?.config_filter_names?.CA_BandFilter?.System?.length
            ? [...currentData[selectedConfig.chartKey]?.config_filter_names?.CA_BandFilter?.System]
            : []
    );
    let isEdit = selectedConfig ? true : false;
    const [selectedBreakdowns, setSelectedBreakdowns] = useState(currentData?.[selectedConfig?.chartKey]?.grouping || {});
    const filterRefs = {};
    const [showColumnConfigModal, setColumnConfigModal] = useState(false);
    const [showMultiColumnConfigModal, setMultiColumnConfigModal] = useState(false);
    const { template, property, ...restList } = currentData?.[selectedConfig?.chartKey]?.config || {};
    const [selectedFields, setSelectedFields] = useState(restList?.list ?? restList?.fields ?? restList ?? {});
    const [selectedTemplate, setSelectedTemplate] = useState(currentData?.[selectedConfig?.chartKey]?.config?.template || "");
    const [selectedProperty, setSelectedProperty] = useState(currentData?.[selectedConfig?.chartKey]?.config?.property || "");
    const [pivotTable, setPivotTable] = useState(currentData?.[selectedConfig?.chartKey]?.config?.is_pivot_table || false);
    const [dropdowns, setDropdowns] = useState(getCAbandDropdownData);
    const [systemDropdown, setSystemDropdown] = useState(getCAbandSystemDropdownData);
    const [tradeDropdown, setTradeDropdown] = useState(getCAbandTradeDropdownData);
    const [systemData, setSystemData] = useState([]);
    const [dataValue, setData] = useState([]);
    const [tradeData, setTradeData] = useState([]);
    const [systemDataName, setSystemDataName] = useState([]);
    const [dataName, setDataName] = useState([]);
    const [tradeDataName, setTradeDataName] = useState([]);
    const [yearBreakdown, setYearBreakdown] = useState(false);
    const [immediateData, setImmediateData] = useState({ label: "", displayImmediateCost: "", inflation: false, inflationLabel: "" });
    const [fields, setFields] = useState([{ label: "", startYear: null, endYear: null, inflation: false, inflationLabel: "" }]);
    const [errors, setErrors] = useState({});
    const [years, setYear] = useState(null);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const { masterFilterList } = useSelector(state => state.dashboardReducer);
    const [menuOpen, setMenuOpen] = useState({ line: false, column: false });
    const [filterData, setFilterData] = useState(currentData?.[selectedConfig?.chartKey]?.config_filters || {});
    const [filterDataName, setFilterDataName] = useState(currentData?.[selectedConfig?.chartKey]?.config_filter_names?.CA_BandFilter || {});
    const [filter, setFilter] = useState(currentData?.[selectedConfig?.chartKey]?.config_filters_ca || {});
    const [columnMenuIsOpen, setColumnMenuIsOpen] = useState(false);
    const [isLegacyExport, setLegacyExport] = useState(currentData?.[selectedConfig?.chartKey]?.is_legacy || false);
    const [legacyExportConfirmationModal, setLegacyExportConfirmationModal] = useState(false);
    const [showAdditionalExportOptionsModal, setShowAdditionalExportOptionsModal] = useState(false);
    const [initialStateReady, setInitialStateReady] = useState(false);
    const [cancelConfirmationModal, setCancelConfirmationModal] = useState(false);

    const [tableConfig, setTableConfig] = useState(currentData?.[selectedConfig?.chartKey]?.table_config || {});
    const options = (isSwitchBandActive ? CA_GEO_HIERARCHY_ELEMENTS : CA_RECOMMENDATION_ELEMENTS)
        .filter(elem => !elem?.columnOnly)
        .map(elem => ({ value: elem.key, label: elem.label }));

    const [selectOptions, setSelectOptions] = useState(
        (isSwitchBandActive ? CA_RECOMMENDATION_ELEMENTS : CA_GEO_HIERARCHY_ELEMENTS).map(cElement => ({
            value: cElement.key,
            label: cElement.label
        }))
    );
    const [selectedElemOption, setSelectedElemOption] = useState(() => {
        if (!selectedConfig?.chartKey) return { line: [], column: [] };
        const lineOptions = CA_RECOMMENDATION_ELEMENTS.map(elem => ({ value: elem.key, label: elem.label }));

        const columnOptions = CA_GEO_HIERARCHY_ELEMENTS.map(cElement => ({
            value: cElement.key,
            label: cElement.label
        }));
        const parts = selectedConfig.chartKey.split("_");

        const processedParts = parts.reduce((acc, part, i) => {
            if (part === "fci" && parts[i + 1] === "benchmarking") {
                acc.push("fci_benchmarking");
            } else if (parts[i - 1] !== "fci") {
                acc.push(part);
            }
            return acc;
        }, []);

        const columnPart = processedParts.at(-2) || "";
        const lineParts = processedParts.slice(0, -2);

        const mapToOptions = (values, optionList) => {
            return optionList.filter(opt => values.includes(opt.value));
        };
        return {
            line: mapToOptions(lineParts, lineOptions),
            column: mapToOptions(currentData?.[selectedConfig?.chartKey]?.year_break_down ? lineParts : [columnPart], columnOptions)
        };
    });
    const getFormSnapshot = () => ({
        selectedBreakdowns,
        selectedFields,
        selectedTemplate,
        selectedProperty,
        pivotTable,
        yearBreakdown,
        immediateData,
        fields,
        filterData,
        filter,
        isLegacyExport,
        tableConfig,
        selectedElements
    });
    const mapValuesToElementOptions = (elementType, values = []) => {
        const elementOptions =
            elementType === "line"
                ? (isSwitchBandActive ? CA_GEO_HIERARCHY_ELEMENTS : CA_RECOMMENDATION_ELEMENTS).filter(elem => !elem?.columnOnly)
                : isSwitchBandActive
                  ? CA_RECOMMENDATION_ELEMENTS
                  : CA_GEO_HIERARCHY_ELEMENTS;

        return elementOptions.map(elem => ({ value: elem.key, label: elem.label })).filter(option => values?.includes(option.value));
    };

    const updateColumnOptionDisables = selectedValues => {
        setSelectOptions(prevOptions =>
            prevOptions.map(opt => ({
                ...opt,
                isDisabled:
                    (selectedValues.includes("recommendations") && opt.value === "asset") ||
                    (selectedValues.includes("asset") && opt.value === "recommendations") ||
                    ((selectedValues.includes("asstcondition") || selectedValues.includes("asset")) && opt.value === "recomcondition") ||
                    ((selectedValues.includes("recomcondition") || selectedValues.includes("recommendations")) && opt.value === "asstcondition")
            }))
        );
    };

    const ignoreNextSelectMenuCloseOnce = () => {
        ignoreNextSelectMenuClose.current = true;
        setTimeout(() => {
            ignoreNextSelectMenuClose.current = false;
        }, 0);
    };

    const applySelectedElementOptions = (elementType, selectedOptions) => {
        const selectedValues = selectedOptions.map(option => option.value);

        handleSelectElements(elementType, selectedValues?.[0], elementType === "line" ? !isSwitchBandActive : isSwitchBandActive, selectedOptions);
    };

    const handlePendingSelectElements = (elementType, selected, actionMeta = {}) => {
        const selectedOptions = Array.isArray(selected) ? selected : selected ? [selected] : [];

        setSelectedElemOption(prevOption => ({
            ...prevOption,
            [elementType]: selectedOptions
        }));

        if (elementType === "column") {
            updateColumnOptionDisables(selectedOptions.map(option => option.value));
        }

        if (["remove-value", "pop-value", "clear"].includes(actionMeta.action)) {
            applySelectedElementOptions(elementType, selectedOptions);
        }
    };

    const handleApplySelectElements = elementType => {
        const selectedOptions = selectedElemOption?.[elementType] || [];

        ignoreNextSelectMenuCloseOnce();
        applySelectedElementOptions(elementType, selectedOptions);
        setMenuOpen(prevMenuOpen => ({ ...prevMenuOpen, [elementType]: false }));
    };

    const handleCancelSelectElements = (elementType, shouldIgnoreNextClose = true) => {
        const committedValues = selectedElements?.[elementType] || [];

        if (shouldIgnoreNextClose) {
            ignoreNextSelectMenuCloseOnce();
        }
        setSelectedElemOption(prevOption => ({
            ...prevOption,
            [elementType]: mapValuesToElementOptions(elementType, committedValues)
        }));

        if (elementType === "column") {
            updateColumnOptionDisables(committedValues);
        }
        setMenuOpen(prevMenuOpen => ({ ...prevMenuOpen, [elementType]: false }));
    };

    const handleSelectMenuClose = elementType => {
        if (ignoreNextSelectMenuClose?.current) {
            ignoreNextSelectMenuClose.current = false;
            return;
        }

        handleCancelSelectElements(elementType, false);
    };

    useEffect(() => {
        let FilterData = [];
        let selectedFilterEntity = CA_RECOMMENDATION_ELEMENTS.find(fi => fi.key == selectedElements.line);
        dispatch(
            dashboardActions.getMasterFilter(
                {
                    client_ids: [selectedClient],
                    dynamic_filters: {},
                    field: ["maintenance_years.year"],
                    filters: {},
                    project_ids: [selectedProject]
                },
                "year",
                true
            )
        );

        if (selectedFilterEntity) {
            FilterData = currentData?.[selectedConfig?.chartKey]?.[selectedFilterEntity?.paramKey]
                ? [...currentData?.[selectedConfig?.chartKey][selectedFilterEntity.paramKey]]
                : [];
        }
        if (selectedElements[isSwitchBandActive ? "column" : "line"] === "subsystem") {
            getCAbandTradeFilterDropDownData("trades", {
                ...getParamsForMasterFilter("trade"),
                system_id: [...selectedFilterValuesSystem],
                sub_system_id: [...FilterData]
            });
        } else if (selectedElements[isSwitchBandActive ? "column" : "line"] === "system") {
            getCAbandTradeFilterDropDownData("trades", {
                ...getParamsForMasterFilter("trade"),
                system_id: [...FilterData]
            });
        } else {
            getCAbandTradeFilterDropDownData("trades", getParamsForMasterFilter("trade"));
        }
        if (selectedConfig?.chartKey && currentData?.[selectedConfig.chartKey]) {
            if (selectedConfig?.chartKey?.includes("subsystem")) {
                getCAbandSystemFilterDropDownData("system", {
                    ...getParamsForMasterFilter("system"),
                    sub_system_id: FilterData?.length > 0 ? [...FilterData] : mfilter?.sub_system_ids,
                    trade_id: selectedFilterValuesTrade?.length > 0 ? [...selectedFilterValuesTrade] : mfilter?.trade_ids
                });
            }
            let isSwitched = currentData?.[selectedConfig.chartKey]?.reverse_cmp_analysis ?? false;
            setYearBreakdown(currentData?.[selectedConfig.chartKey]?.year_break_down || false);
            if (isSwitched) {
                switchBandElements(true);
            }
            let selectedFilterEntity = CA_RECOMMENDATION_ELEMENTS.find(fi => fi.key == selectedElements.line);
            if (selectedFilterEntity) {
                let tempSelectedFilterValues = currentData[selectedConfig.chartKey]?.[selectedFilterEntity?.paramKey]
                    ? [...currentData[selectedConfig.chartKey][selectedFilterEntity.paramKey]]
                    : [];
                // initialElements.current = selectedConfig?.chartKey;
                if (selectedFilterEntity.hasFilter) {
                    if (selectedConfig?.chartKey?.includes("subsystem")) {
                        getCAbandFilterDropDownData("subsystem", {
                            ...getParamsForMasterFilter("subsystem"),
                            system_id: selectedFilterValuesSystem?.length > 0 ? [...selectedFilterValuesSystem] : mfilter?.system_ids,
                            trade_id: selectedFilterValuesTrade?.length > 0 ? [...selectedFilterValuesTrade] : mfilter?.trade_ids
                        });
                    } else {
                        getCAbandFilterDropDownData(selectedFilterEntity.key, getParamsForMasterFilter(selectedFilterEntity.key));
                    }
                    setSelectedFilterValues(tempSelectedFilterValues);
                    setSelectedFilterName(
                        currentData[selectedConfig.chartKey]?.config_filter_names?.CA_BandFilter?.[selectedFilterEntity?.label]
                            ? [...currentData[selectedConfig.chartKey]?.config_filter_names?.CA_BandFilter?.[selectedFilterEntity?.label]]
                            : []
                    );
                    setFilterLabel(selectedFilterEntity);
                }
            } else if (currentData?.[selectedConfig?.chartKey]?.year_break_down) {
                initialElements.current = selectedConfig?.chartKey;
            }
            initialElements.current = selectedConfig?.chartKey;
        }
        setInitialStateReady(true);
    }, []);

    useEffect(() => {
        if (initialStateReady && !initialFormSnapshot.current) {
            initialFormSnapshot.current = getFormSnapshot();
        }
    }, [initialStateReady]);

    const handleSelectElements = (elementType, value, changeFilterItems = false, elem) => {
        const updatedSelectedElemOption = { ...selectedElemOption, [elementType]: elem };
        const updatedSelectedElements = {
            ...selectedElements,
            [elementType]: (elem || []).map(e => e?.value) || []
        };

        setSelectedElemOption(updatedSelectedElemOption);
        setSelectedElements(updatedSelectedElements);

        if (changeFilterItems) {
            const selectedFilterItem = CA_RECOMMENDATION_ELEMENTS.find(
                fi => fi.key === (value === "breakdownyears" ? updatedSelectedElements.line : value)
            );

            setFilterLabel(selectedFilterItem);
            setSelectedFilterValues([]);
            setSelectedFilterValuesTrade([]);
            setSelectedFilterValuesSystem([]);
            setSelectedFilterTrade([]);
            setSelectedFilterSystem([]);
            setSelectedFilterName([]);

            if (selectedFilterItem?.hasFilter) {
                getCAbandFilterDropDownData(value, getParamsForMasterFilter(value));
                if (value === "subsystem") {
                    getCAbandSystemFilterDropDownData("system", getParamsForMasterFilter("system"));
                }
            }
        }

        modifyFilterBasedOnColumnSelection(updatedSelectedElements);
        updateSelectedFieldsBasedOnSelection(updatedSelectedElements);
        if (elementType === "line") setSelectedBreakdowns({});
    };

    const modifyFilterBasedOnColumnSelection = selectedElements => {
        const selectedWithParents = new Set();
        selectedElements.column.forEach(key => {
            selectedWithParents.add(key);

            const element = CA_RECOMMENDATION_ELEMENTS.find(e => e.key === key);
            element?.parentFilters?.forEach(parentKey => selectedWithParents.add(parentKey));
        });

        setFilter(prevFilter =>
            Object.keys(prevFilter).reduce((acc, key) => {
                if (selectedWithParents.has(key)) acc[key] = prevFilter[key];
                return acc;
            }, {})
        );

        setFilterData(prevFilterData =>
            Object.keys(prevFilterData).reduce((acc, paramKey) => {
                const matchedElement = CA_RECOMMENDATION_ELEMENTS.find(e => e.paramKey === paramKey);
                if (matchedElement && selectedWithParents.has(matchedElement.key)) {
                    acc[paramKey] = prevFilterData[paramKey];
                }
                return acc;
            }, {})
        );

        setFilterDataName(prevFilterDataName =>
            Object.keys(prevFilterDataName).reduce((acc, label) => {
                const matchedElement = CA_RECOMMENDATION_ELEMENTS.find(e => e.label === label);
                if (matchedElement && selectedWithParents.has(matchedElement.key)) {
                    acc[label] = prevFilterDataName[label];
                }
                return acc;
            }, {})
        );
    };

    const updateSelectedFieldsBasedOnSelection = selectedElements => {
        if (selectedElements.column?.length > 1) {
            const selectedKeys = new Set([...(selectedElements.column || []), ...(selectedElements.line || [])]);

            setSelectedFields(prevSelectedFields =>
                Object.keys(prevSelectedFields || {}).reduce((acc, key) => {
                    if (selectedKeys.has(key)) {
                        acc[key] = prevSelectedFields[key];
                    }
                    return acc;
                }, {})
            );
        } else {
            setSelectedFields({});
        }
    };

    useEffect(() => {
        const options = (isSwitchBandActive ? CA_RECOMMENDATION_ELEMENTS : CA_GEO_HIERARCHY_ELEMENTS).map(cElement => ({
            value: cElement.key,
            label: cElement.label
        }));
        setSelectOptions(options);
    }, [isSwitchBandActive]);

    useEffect(() => {
        if (getCAbandDropdownData && mfilter?.[filterLabel?.paramKey == "subsystem_ids" ? "sub_system_ids" : filterLabel?.paramKey]?.length > 0) {
            setDropdowns(
                getCAbandDropdownData?.filter(value =>
                    mfilter?.[filterLabel?.paramKey == "subsystem_ids" ? "sub_system_ids" : filterLabel?.paramKey]?.includes(value?.id)
                )
            );
        } else {
            setDropdowns(getCAbandDropdownData);
        }
        if (getCAbandSystemDropdownData && mfilter?.["system_ids"]?.length > 0) {
            setSystemDropdown(getCAbandSystemDropdownData?.filter(value => mfilter?.["system_ids"]?.includes(value?.id)));
        } else {
            setSystemDropdown(getCAbandSystemDropdownData);
        }

        if (getCAbandTradeDropdownData && mfilter?.["trade_ids"]?.length > 0) {
            setTradeDropdown(getCAbandTradeDropdownData?.filter(value => mfilter?.["trade_ids"]?.includes(value?.id)));
        } else {
            setTradeDropdown(getCAbandTradeDropdownData);
        }
    }, [getCAbandDropdownData, getCAbandSystemDropdownData, getCAbandTradeDropdownData]);
    useEffect(() => {
        if (dropdowns?.length > 0 && selectedFilterValues?.length > 0) {
            const ids = [];
            const names = [];

            dropdowns.forEach(item => {
                if (selectedFilterValues.includes(item.id)) {
                    ids.push(item.id);
                    names.push(item.name);
                }
            });
            setSelectedFilterValues(ids);
            setSelectedFilterName(names);
        }
        if (systemDropdown?.length > 0 && selectedFilterValuesSystem?.length > 0) {
            const ids = [];
            const names = [];

            systemDropdown.forEach(item => {
                if (selectedFilterValuesSystem.includes(item.id)) {
                    ids.push(item.id);
                    names.push(item.name);
                }
            });
            setSelectedFilterValuesSystem(ids);
            setSelectedFilterSystem(names);
        }
        if (tradeDropdown?.length > 0 && selectedFilterValuesTrade?.length > 0) {
            const ids = [];
            const names = [];

            tradeDropdown.forEach(item => {
                if (selectedFilterValuesTrade.includes(item.id)) {
                    ids.push(item.id);
                    names.push(item.name);
                }
            });
            setSelectedFilterValuesTrade(ids);
            setSelectedFilterTrade(names);
        }
    }, [systemDropdown, dropdowns, tradeDropdown]);
    const getParamsForMasterFilter = key => {
        let currentUser = localStorage.getItem("userId") || "";
        const { project_ids, region_ids, site_ids, building_ids, building_type_ids, ...restMfilter } = mfilter;
        switch (key) {
            case "category":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };

            case "system":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    trade_id: selectedFilterValuesTrade.length ? [...selectedFilterValuesTrade] : null,
                    ...restMfilter
                };
            case "criticality":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };
            case "responsibility":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };
            case "term":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };
            case "fundingsrc":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };
            case "trade":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };
            case "capital":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };
            case "subsystem":
                // const { trade_ids: subsystemTradeIds, system_ids: subsystemsystemIds, ...subsystemRestMfilter } = restMfilter;
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    trade_id: selectedFilterValuesTrade.length ? [...selectedFilterValuesTrade] : null,
                    system_id: selectedFilterValuesSystem.length ? [...selectedFilterValuesSystem] : null,
                    ...restMfilter
                };
            case "asstcondition":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };
            case "recomcondition":
                return {
                    project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
                    region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
                    site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
                    building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
                    building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
                    user_id: currentUser,
                    ...restMfilter
                };
            default:
                return {};
        }
    };

    const validate = () => {
        setShowErrorBorder(false);
        if (yearBreakdown && (!selectedElements.line || selectedElements.line.length === 0)) {
            setShowErrorBorder(true);
            return false;
        } else if (
            !yearBreakdown &&
            (!selectedElements.line || selectedElements.line.length === 0 || !selectedElements.column || selectedElements.column.length === 0)
        ) {
            setShowErrorBorder(true);
            return false;
        }

        if (
            selectedElements.line.length === 1 &&
            selectedElements.line[0] === "fciefci" &&
            selectedElements.column.length === 1 &&
            selectedElements.column[0] === "recomtype"
        ) {
            showAlert("Oops.. This CA combination not allowed at the moment!");
            return false;
        }

        if (
            selectedElements.column.length === 1 &&
            selectedElements.column[0] === "recomtype" &&
            Object.keys(selectedBreakdowns)?.length &&
            Object.entries(selectedBreakdowns).some(([key, value]) => value)
        ) {
            showAlert("Oops.. Breakdown summary with recommendation criticality type is not allowed at the moment!");
            return false;
        }

        if (selectedElements?.column && selectedElements.column.length === 1) {
            const colKey = selectedElements.column[0];
            const colElement = CA_RECOMMENDATION_ELEMENTS.find(item => item.key === colKey);
            if (colElement?.hasColumnSelect && !Object.keys(selectedFields).length) {
                showAlert("Please select columns");
                return false;
            }
        }
        if (
            selectedElements?.column &&
            (selectedElements.column.length > 1 || (selectedElements.column.length === 1 && selectedElements.column[0] === "recomtype"))
        ) {
            let requiredKeys = [...selectedElements.column];

            if (requiredKeys.includes("fciefci") && requiredKeys.includes("fci_benchmarking")) {
                const index = requiredKeys.indexOf("fciefci");
                requiredKeys.splice(index, 1);
            }
            requiredKeys = requiredKeys.filter(key => key !== "recomcondition" && key !== "assetcondition");

            if (!Object.keys(selectedFields).length || !requiredKeys.every(key => key in selectedFields)) {
                showAlert("Please filter/select columns");
                return false;
            }
        }

        if (yearBreakdown) {
            const allLabels = new Map();
            let newErrors = {};
            let hasError = false;

            const checkAndAddLabel = (label, index, type, typeName) => {
                if (!label || !label?.trim()) {
                    newErrors[`field-${index}-${type}`] = `Missing ${typeName}`;
                    hasError = true;
                    return;
                }

                const trimmedLabel = label?.trim()?.toLowerCase();

                if (allLabels.has(trimmedLabel)) {
                    const { duplicateIndex, duplicateType } = allLabels?.get(trimmedLabel);
                    newErrors[`field-${index}-${type}`] = `Duplicate ${typeName}`;
                    newErrors[`field-${duplicateIndex}-${duplicateType}`] = `Duplicate ${duplicateType}`;
                    hasError = true;
                } else {
                    allLabels.set(trimmedLabel, { duplicateIndex: index, duplicateType: type });
                }
            };

            if (immediateData?.displayImmediateCost) {
                checkAndAddLabel(immediateData?.label?.trim()?.toLowerCase(), "immediate", "label", "Label");
            }
            if (immediateData?.displayImmediateCost && immediateData?.inflation) {
                checkAndAddLabel(immediateData?.inflationLabel?.trim()?.toLowerCase(), "immediate", "inflation", "Inflation Label");
            }

            for (let index = 0; index < fields?.length; index++) {
                const field = fields?.[index];
                if (field?.startYear?.value) {
                    checkAndAddLabel(field?.label?.trim()?.toLowerCase(), index, "label", "Label");
                    if (field?.inflation) {
                        checkAndAddLabel(field?.inflationLabel?.trim()?.toLowerCase(), index, "inflation", "Inflation Label");
                    }
                }
            }

            if (hasError) {
                setErrors(newErrors);
                return false;
            }

            return true;
        }
        return true;
    };

    const handleSaveConfig = () => {
        if (validate()) {
            let configValue = {
                reverse_cmp_analysis: isSwitchBandActive,
                table_view: "",
                remove_section_break: currentData?.[selectedConfig?.chartKey]?.remove_section_break ?? false,
                year_break_down: yearBreakdown,
                heading: currentData?.[selectedConfig?.chartKey]?.heading || {},
                immediate_column: immediateData?.displayImmediateCost,
                inflation_column: immediateData?.inflation || fields?.some(field => field?.inflation === true)
            };
            if (selectedFilterValues.length) {
                configValue = {
                    [filterLabel.paramKey]: [...selectedFilterValues],
                    reverse_cmp_analysis: isSwitchBandActive,
                    year_break_down: yearBreakdown,
                    immediate_column: immediateData?.displayImmediateCost,
                    inflation_column: immediateData?.inflation || fields?.some(field => field?.inflation === true),
                    table_view: "",
                    remove_section_break: currentData?.[selectedConfig?.chartKey]?.remove_section_break ?? false,
                    config_filter_names: {
                        ...configValue.config_filter_names,
                        CA_BandFilter: {
                            ...(configValue.config_filter_names && configValue.config_filter_names.CA_BandFilter),
                            [filterLabel?.label]: [...selectedFilterName]
                        }
                    }
                };
            }
            if (Object.keys(selectedBreakdowns)?.length && selectedElements.column?.length === 1 && selectedElements.column[0] !== "recomtype") {
                configValue = {
                    ...configValue,
                    grouping: selectedBreakdowns
                };
            }
            if (
                Object.keys(selectedFields).length &&
                selectedElements.column?.length === 1 &&
                (selectedElements.column.includes("recommendations") || selectedElements.column.includes("asset"))
            ) {
                configValue = {
                    ...configValue,
                    config: {
                        template: selectedTemplate,
                        property: selectedProperty,
                        fields: selectedFields
                    }
                };
            }
            if (Object.keys(selectedFields).length && (selectedElements.column?.length > 1 || selectedElements.column.includes("recomtype"))) {
                configValue = {
                    ...configValue,
                    table_config: tableConfig,
                    config: {
                        template: selectedTemplate,
                        property: selectedProperty,
                        ...selectedFields
                    },
                    config_filter_names: { CA_BandFilter: filterDataName },
                    config_filters: { ...filterData },
                    config_filters_ca: { ...filter },
                    ...filterData
                };
                if (showLegacyExport) {
                    configValue = {
                        ...configValue,
                        is_legacy: isLegacyExport
                    };
                }
            }
            if (
                (selectedElements.column.includes("recommendations") || selectedElements.column.includes("asset")) &&
                isExcelExport &&
                selectedElements.column?.length === 1
            ) {
                configValue = {
                    ...configValue,
                    config: {
                        ...configValue?.config,
                        is_pivot_table: pivotTable
                    }
                };
            }
            if (yearBreakdown) {
                configValue = {
                    ...configValue,
                    break_down_years: { ...handleSaveBreakdownYears() }
                };
            }
            const formatSelectedElements = selectedElements => {
                const line = Array.isArray(selectedElements.line) ? selectedElements.line.join("_") : selectedElements.line;

                const column = Array.isArray(selectedElements.column) ? selectedElements?.column?.join("_") : selectedElements.column;

                return `${line}_${column}`;
            };

            let selectedTileKey = isSwitchBandActive
                ? yearBreakdown
                    ? `${Array.isArray(selectedElements.line) ? selectedElements.line.join("_") : selectedElements.line}_breakdownyears`
                    : `${
                          Array.isArray(selectedElements.line) ? selectedElements.column.join("_") : selectedElements.line
                      }_${selectedElements.line.join("_")}`
                : yearBreakdown
                  ? `${Array.isArray(selectedElements.line) ? selectedElements.line.join("_") : selectedElements.line}_breakdownyears`
                  : formatSelectedElements(selectedElements);
            if (
                (selectedTileKey.includes("system") || selectedTileKey.includes("subsystem") || selectedTileKey.includes("trade")) &&
                selectedElements?.column?.length === 1
            ) {
                configValue = {
                    ...configValue,
                    trade_ids: selectedTileKey.includes("trade") ? [...selectedFilterValues] : [...selectedFilterValuesTrade],
                    config_filter_names: {
                        ...configValue.config_filter_names,
                        CA_BandFilter: {
                            ...(configValue.config_filter_names && configValue.config_filter_names.CA_BandFilter),
                            Trade: selectedTileKey.includes("trade") ? [...selectedFilterName] : [...selectedFilterTrade]
                        }
                    }
                };
                if (selectedTileKey.includes("subsystem")) {
                    configValue = {
                        ...configValue,
                        system_ids: [...selectedFilterValuesSystem],
                        config_filter_names: {
                            ...configValue.config_filter_names,
                            CA_BandFilter: {
                                ...(configValue.config_filter_names && configValue.config_filter_names.CA_BandFilter),
                                System: [...selectedFilterSystem]
                            }
                        }
                    };
                }
            }
            if (isEdit && initialElements.current !== selectedTileKey) {
                setSmartChartData("replace_ca_band", {
                    bandName: "band1",
                    entity: entity,
                    customTileKey: selectedTileKey + "_" + uuid(),
                    customTileData: {
                        ...configValue
                    },
                    prevTileKey: initialElements.current
                });
            } else {
                setSmartChartData("custom_tile", {
                    bandName: "band1",
                    entity: entity,
                    customTileKey: selectedTileKey + "_" + uuid(),
                    customTileData: {
                        ...configValue
                    },
                    isEditing: isEdit
                });
            }
            onCancel();
        }
    };

    const renderFilteredList = key => {
        let filteredList = [];
        if (key === "trade") {
            if (tradeDropdown?.length) {
                filteredList = searchValueTrade?.trim()?.length
                    ? tradeDropdown.filter(item => item.name?.toString()?.toLowerCase()?.includes(searchValueTrade?.toLocaleLowerCase()))
                    : tradeDropdown;
            }
        } else if (key === "system") {
            if (systemDropdown?.length) {
                filteredList = searchValueSystem?.trim()?.length
                    ? systemDropdown.filter(item => item.name?.toString()?.toLowerCase()?.includes(searchValueSystem?.toLocaleLowerCase()))
                    : systemDropdown;
            }
        } else {
            if (dropdowns?.length) {
                filteredList = searchValue?.trim()?.length
                    ? dropdowns.filter(item => item.name?.toString()?.toLowerCase()?.includes(searchValue?.toLocaleLowerCase()))
                    : dropdowns;
            }
        }

        return filteredList;
    };

    const handleClickDropdown = (label, type) => {
        let id = {};
        if (label === "Sub-System" || label == "System") {
            if (label === "Sub-System") {
                if (selectedFilterValuesTrade.length > 0) {
                    id.trade_ids = [...selectedFilterValuesTrade];
                }
                if (selectedFilterValuesSystem.length > 0) {
                    id.system_ids = [...selectedFilterValuesSystem];
                }

                getCAbandFilterDropDownData("subsystem", {
                    ...getParamsForMasterFilter("subsystem"),
                    ...id
                });
            }
            if (label === "System") {
                if (selectedFilterValuesTrade.length > 0) {
                    id.trade_ids = [...selectedFilterValuesTrade];
                }
                getCAbandFilterDropDownData("system", {
                    ...getParamsForMasterFilter("system"),
                    ...id
                });
            }
        }
        if (type === "submit") {
            setSelectedFilterValues(dataValue);
            setSelectedFilterName(dataName);
        }
        if (type === "cancel") {
            setSelectedFilterValues([...selectedFilterValues]);
            setSelectedFilterName([...selectedFilterName]);
        }
        if (type === "dropdown") {
            setData([...selectedFilterValues]);
            setDataName([...selectedFilterName]);
        }
        setShowDropDown(prevValue => {
            return !prevValue;
        });

        setShowTradeDropDown(false);
        setShowSystemDropDown(false);
    };

    useEffect(() => {
        if (filterRefs["common"] && showDropDown) {
            filterRefs["common"]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
        }
    }, [showDropDown, filterRefs]);
    useEffect(() => {
        if (filterRefs["trade"] && showTradeDropDown) {
            filterRefs["trade"]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
        }
    }, [showTradeDropDown, filterRefs]);
    useEffect(() => {
        if (filterRefs["system"] && showSystemDropDown) {
            filterRefs["system"]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
        }
    }, [showSystemDropDown, filterRefs]);

    useEffect(() => {
        if (
            selectedElements.line &&
            selectedElements.column &&
            CA_RECOMMENDATION_ELEMENTS.find(item => item.key === selectedElements?.column)?.hasColumnSelect &&
            !Object.keys(selectedFields).length
        ) {
            fetchColumns();
        }
    }, [selectedElements]);

    useEffect(() => {
        if (selectedConfig?.selectedTile?.tileData) {
            setFields(mapConfigToFields(selectedConfig?.selectedTile?.tileData?.break_down_years));
        }
    }, [selectedConfig]);

    useEffect(() => {
        if (masterFilterList && masterFilterList?.year) {
            let graphData = masterFilterList?.year;
            let yearValues = graphData?.map(item => item?.name) || [];
            setYear(yearValues);
            if (!viewOnly && yearValues) {
                dispatch(
                    actions?.getDefaultYearBreakdownProperty({
                        chart_property_id: selectedExportProperty,
                        break_down_years_list: yearValues?.join(","),
                        immediate_column: true,
                        inflation_column: true
                    })
                );
            }
        }
    }, [masterFilterList?.year]);
    useEffect(() => {
        if (getDefaultYearBreakdownResponse?.success && !selectedConfig?.selectedTile?.tileData?.break_down_years?.break_down_1?.label) {
            if (getDefaultYearBreakdownResponse?.data?.break_down_years && !fields?.[0]?.label) {
                const newFields = mapConfigToFields(getDefaultYearBreakdownResponse?.data?.break_down_years);
                setFields(newFields);

                // to save the immedial & field value to the initialFormSnapshot to compare with the current form value on cancel
                const immediateValue = getDefaultYearBreakdownResponse?.data?.break_down_years?.break_down_1;
                const immediateData = {
                    label: immediateValue?.label,
                    displayImmediateCost: immediateValue?.r_criticality_type,
                    inflation: Object?.keys(immediateValue?.sub_break_down || {})?.includes("label"),
                    inflationLabel: immediateValue?.sub_break_down?.label
                };

                initialFormSnapshot.current = { ...getFormSnapshot(), immediateData: immediateData, fields: newFields };
            }
        }
    }, [getDefaultYearBreakdownResponse]);

    const fetchColumns = async () => {
        const { line, column } = selectedElements;
        const params = {
            keyword: column + "_" + line,
            client_id: selectedClient || "",
            project_id: selectedProject || ""
        };
        dispatch(actions.getCaColumns(params, column));
    };

    const handleSelectDropdown = (selectedId, key, data) => {
        if (key === "trade" || key === "Trade") {
            let tempSelectedItems = [...tradeData];
            let tempSelectedName = [...tradeDataName];
            if (tradeData.includes(selectedId)) {
                tempSelectedItems = tempSelectedItems.filter(id => id !== selectedId);
                tempSelectedName = tempSelectedName.filter(item => item !== data?.name);
            } else {
                tempSelectedItems.push(selectedId);
                tempSelectedName.push(data?.name);
            }
            setTradeData([...tempSelectedItems]);
            setTradeDataName([...tempSelectedName]);
            if (key === "Trade") {
                setData([...tempSelectedItems]);
                setDataName([...tempSelectedName]);
            }
        } else if (key === "system") {
            let tempSelectedItems = [...systemData];
            let tempSelectedName = [...systemDataName];
            if (systemData.includes(selectedId)) {
                tempSelectedItems = tempSelectedItems.filter(id => id !== selectedId);
                tempSelectedName = tempSelectedName.filter(item => item !== data?.name);
            } else {
                tempSelectedItems.push(selectedId);
                tempSelectedName.push(data?.name);
            }
            setSystemData([...tempSelectedItems]);
            setSystemDataName([...tempSelectedName]);
        } else {
            let tempSelectedItems = [...dataValue];
            let tempSelectedName = [...dataName];
            if (dataValue.includes(selectedId)) {
                tempSelectedItems = tempSelectedItems.filter(id => id !== selectedId);
                tempSelectedName = tempSelectedName.filter(item => item !== data?.name);
            } else {
                tempSelectedItems.push(selectedId);
                tempSelectedName.push(data?.name);
            }
            setData([...tempSelectedItems]);
            setDataName([...tempSelectedName]);
        }
    };

    const handleSelectAll = async (isChecked, key) => {
        let temp = [];
        let tempValue = [];
        if (key === "trade") {
            if (tradeDropdown?.length) {
                tradeDropdown.map(data => temp.push(data.id));
                tradeDropdown.map(data => tempValue.push(data.name));
            }
            setTradeData(isChecked ? [...temp] : []);
            setTradeDataName(isChecked ? [...tempValue] : []);
        } else if (key === "system") {
            if (systemDropdown?.length) {
                systemDropdown.map(data => temp.push(data.id));
                systemDropdown.map(data => tempValue.push(data.name));
            }
            setSystemData(isChecked ? [...temp] : []);
            setSystemDataName(isChecked ? [...tempValue] : []);
        } else {
            if (dropdowns?.length) {
                dropdowns.map(data => temp.push(data.id));
                dropdowns.map(data => tempValue.push(data.name));
            }
            setData(isChecked ? [...temp] : []);
            setDataName(isChecked ? [...tempValue] : []);
        }
    };

    const switchBandElements = (isInitialCall = false) => {
        setMenuOpen({ line: false, column: false });
        setIsSwitchBandActive(prevValue => !prevValue);
        setSelectedElements(prevValue => {
            const nextSelectedElements = {
                line:
                    [...CA_GEO_HIERARCHY_ELEMENTS, ...CA_RECOMMENDATION_ELEMENTS].find(item => item.key === prevValue.column[0])?.columnOnly ||
                    prevValue.column?.length > 1 ||
                    (yearBreakdown && isSwitchBandActive)
                        ? []
                        : prevValue.column,
                column: yearBreakdown ? [] : prevValue.line
            };
            if (isInitialCall) {
                initialFormSnapshot.current = {
                    ...initialFormSnapshot?.current,
                    selectedElements: nextSelectedElements
                };
            }
            return nextSelectedElements;
        });
        setSelectedElemOption(prevOption => ({
            line:
                (yearBreakdown && isSwitchBandActive) ||
                prevOption.column.length > 1 ||
                (prevOption.column.length === 1 &&
                    [...CA_GEO_HIERARCHY_ELEMENTS, ...CA_RECOMMENDATION_ELEMENTS].find(item => item.key === prevOption.column[0]?.value)?.columnOnly)
                    ? []
                    : prevOption.column,
            column: yearBreakdown ? [] : prevOption.line
        }));
        if (selectedElements?.column === "breakdownyears" || selectedElements?.line === "breakdownyears") {
            setSelectedFilterValues([]);
            setSelectedFilterValuesTrade([]);
            setSelectedFilterValuesSystem([]);
            setSelectedFilterTrade([]);
            setSelectedFilterSystem([]);
            setSelectedFilterName([]);
        }
    };
    const handleClickTradeDropdown = type => {
        if (type === "dropdown") {
            setTradeData([...selectedFilterValuesTrade]);
            setTradeDataName([...selectedFilterTrade]);
        }
        if (type === "submit") {
            setSelectedFilterValuesTrade(tradeData);
            setSelectedFilterTrade(tradeDataName);
        }
        if (type === "cancel") {
            setTradeData([...selectedFilterValuesTrade]);
            setTradeDataName([...selectedFilterTrade]);
        }

        let id = {};
        if (selectedElements.line === "subsystem" || selectedElements.column === "subsystem") {
            if (selectedFilterValuesSystem.length > 0) {
                id.system_ids = [...selectedFilterValuesSystem];
            }
            if (selectedFilterValues.length > 0) {
                id.sub_system_ids = [...selectedFilterValues];
            }
        } else if (selectedElements.line === "system" || selectedElements.column === "system") {
            if (selectedFilterValues.length > 0) {
                id.system_ids = [...selectedFilterValues];
            }
        }
        getCAbandTradeFilterDropDownData("trade", {
            ...getParamsForMasterFilter("trade"),
            ...id
        });
        setShowTradeDropDown(prevValue => {
            return !prevValue;
        });
        setShowDropDown(false);
    };

    const handleClickSystemDropdown = type => {
        if (type === "dropdown") {
            setSystemData([...selectedFilterValuesSystem]);
            setSystemDataName([...selectedFilterSystem]);
        }
        if (type === "submit") {
            setSelectedFilterValuesSystem(systemData);
            setSelectedFilterSystem(systemDataName);
        }
        if (type === "cancel") {
            setSystemData([...selectedFilterValuesSystem]);
            setSystemDataName([...selectedFilterSystem]);
        }
        let id = {};
        if (selectedElements.line === "subsystem" || selectedElements.column === "subsystem") {
            if (selectedFilterValuesTrade.length > 0) {
                id.trade_ids = [...selectedFilterValuesTrade];
            }
            if (selectedFilterValues.length > 0) {
                id.sub_system_ids = [...selectedFilterValues];
            }
        } else if (selectedElements.line === "system" || selectedElements.column === "system") {
            if (selectedFilterValuesTrade.length > 0) {
                id.trade_ids = [...selectedFilterValuesTrade];
            }
        }
        getCAbandSystemFilterDropDownData("system", {
            ...getParamsForMasterFilter("system"),
            ...id
        });
        setShowSystemDropDown(prevValue => {
            return !prevValue;
        });
        setShowDropDown(false);
    };

    const handleSelectBreakdown = e => {
        const { name, checked } = e.target;
        setSelectedBreakdowns({ ...selectedBreakdowns, [name]: checked });
    };

    const renderFilters = type => {
        return (
            <>
                {CA_RECOMMENDATION_ELEMENTS.find(item => item.key === selectedElements?.[type]?.[0])?.hasFilter && (
                    <>
                        {selectedElements[type]?.[0] === "system" || selectedElements[type]?.[0] === "subsystem" ? (
                            <>
                                <div className={`otr-form col-md-12 p-0 d-flex mt-3`} ref={node => (filterRefs["trade"] = node)}>
                                    <div className={`selct-otr col-md-12 p-0`}>
                                        <div className="grid-inner d-flex category-selc-drp">
                                            <div
                                                className={`grid-box position-relative ${selectedFilterValuesTrade?.length ? "bg-th-filtered" : ""}`}
                                                onClick={() => handleClickTradeDropdown("dropdown")}
                                            >
                                                <div className={`dropdown-container ${showTradeDropDown ? "dropdown-open" : ""} `}>
                                                    <div className="dropdown-toggle click-dropdown">
                                                        Trade
                                                        <span className="close-reg">
                                                            <i className="fas fa-chevron-down" />
                                                        </span>
                                                    </div>
                                                    {showTradeDropDown && (
                                                        <div className={`dropdown-menu p-0 ${showTradeDropDown ? "dropdown-active" : ""}`}>
                                                            <div className="drop-filtr dp-rcm-overflow" onClick={e => e.stopPropagation()}>
                                                                <div className="col-md-12 p-0 border-bottom pt-1">
                                                                    <span className="dropdown-item build_search_drp">
                                                                        <input
                                                                            type="search"
                                                                            placeholder="Search..."
                                                                            value={searchValueTrade}
                                                                            onChange={e => {
                                                                                let value = e.target.value;
                                                                                setSearchValueTrade(prevSearch => {
                                                                                    return value;
                                                                                });
                                                                            }}
                                                                        />
                                                                        <i
                                                                            className="fas fa-times cursor-pointer cls-close"
                                                                            onClick={() =>
                                                                                setSearchValueTrade(prevSearch => {
                                                                                    return "";
                                                                                })
                                                                            }
                                                                        />
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-12 p-0 border-bottom pt-1">
                                                                    <div className="dropdown-item select_section_outer">
                                                                        <label className={`container-check ${viewOnly ? "cursor-disabled" : ""}`}>
                                                                            Select all
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={
                                                                                    tradeData.length && tradeDropdown?.length == tradeData.length
                                                                                }
                                                                                onClick={e => handleSelectAll(e.target.checked, "trade")}
                                                                                disabled={viewOnly}
                                                                            />
                                                                            <span className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                        </label>
                                                                        <button
                                                                            className={`clear-btn-selection ${viewOnly ? "cursor-disabled" : ""}`}
                                                                            onClick={() => {
                                                                                setTradeData([]);
                                                                                setTradeDataName([]);
                                                                            }}
                                                                            disabled={viewOnly}
                                                                        >
                                                                            Clear
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12 p-0 slt-ara border-bottom dpr-wide-txt">
                                                                    {tradeDropdown
                                                                        ?.filter(fi => tradeData?.includes(fi.id))
                                                                        ?.map(data => (
                                                                            <span className="dropdown-item" key={data.id}>
                                                                                <label
                                                                                    className={`container-check ${viewOnly ? "cursor-disabled" : ""}`}
                                                                                >
                                                                                    <span
                                                                                        className="text-short"
                                                                                        data-tip={
                                                                                            data.name?.length + data?.description?.length > 25
                                                                                                ? `${data.name} ${
                                                                                                      data.description ? `(${data.description})` : ""
                                                                                                  }`
                                                                                                : null
                                                                                        }
                                                                                        data-effect="solid"
                                                                                        data-for="smart-chart-master-filter"
                                                                                        data-place="left"
                                                                                        data-background-color="#007bff"
                                                                                        data-delay-show="500"
                                                                                    >
                                                                                        {data.name} {data.description ? `(${data.description})` : ""}
                                                                                    </span>
                                                                                    {data.count ? (
                                                                                        <span className="count-num"> ({data.count})</span>
                                                                                    ) : null}
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={tradeData.includes(data.id)}
                                                                                        onChange={e => handleSelectDropdown(data.id, "trade", data)}
                                                                                        disabled={viewOnly}
                                                                                    />
                                                                                    <span
                                                                                        className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}
                                                                                    />
                                                                                </label>
                                                                            </span>
                                                                        ))}
                                                                </div>
                                                                {renderFilteredList("trade")?.filter(fi => !tradeData?.includes(fi.id))?.length ? (
                                                                    <div className="col-md-12 p-0 slt-ara overflw-ht dpr-wide-txt">
                                                                        {renderFilteredList("trade")
                                                                            ?.filter(fi => !tradeData?.includes(fi.id))
                                                                            ?.map(data => (
                                                                                <span className="dropdown-item" key={data.id}>
                                                                                    <label
                                                                                        className={`container-check ${
                                                                                            viewOnly ? "cursor-disabled" : ""
                                                                                        }`}
                                                                                    >
                                                                                        <span
                                                                                            className="text-short"
                                                                                            data-tip={
                                                                                                data.name?.length + data?.description?.length > 25
                                                                                                    ? `${data.name} ${
                                                                                                          data.description
                                                                                                              ? `(${data.description})`
                                                                                                              : ""
                                                                                                      }`
                                                                                                    : null
                                                                                            }
                                                                                            data-effect="solid"
                                                                                            data-for="smart-chart-master-filter"
                                                                                            data-place="left"
                                                                                            data-background-color="#007bff"
                                                                                            data-delay-show="500"
                                                                                        >
                                                                                            {data.trade ? `${data.trade}-` : ""}
                                                                                            {data.name}{" "}
                                                                                            {data.description ? `(${data.description})` : ""}
                                                                                        </span>
                                                                                        {data.count ? (
                                                                                            <span className="count-num"> ({data.count})</span>
                                                                                        ) : null}
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={false}
                                                                                            onChange={e =>
                                                                                                handleSelectDropdown(data.id, "trade", data)
                                                                                            }
                                                                                            disabled={viewOnly}
                                                                                        />
                                                                                        <span
                                                                                            className={`checkmark ${
                                                                                                viewOnly ? "cursor-disabled" : ""
                                                                                            }`}
                                                                                        />
                                                                                    </label>
                                                                                </span>
                                                                            ))}
                                                                    </div>
                                                                ) : (
                                                                    <div className={`col-md-12`}>
                                                                        {renderFilteredList("trade")?.filter(
                                                                            fi => !selectedFilterValuesTrade?.includes(fi.id)
                                                                        )?.length === 0
                                                                            ? "No data Found"
                                                                            : ""}
                                                                    </div>
                                                                )}
                                                                <div className="col-md-12 drp-btn">
                                                                    <button
                                                                        type="button"
                                                                        className={`btn btn-primary ${viewOnly ? "cursor-disabled" : ""}`}
                                                                        onClick={() => handleClickTradeDropdown("submit")}
                                                                        disabled={viewOnly}
                                                                    >
                                                                        ok
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btnClr ml-2"
                                                                        onClick={() => handleClickTradeDropdown("cancel")}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {selectedElements[isSwitchBandActive ? "column" : "line"] === "subsystem" ? (
                                    <div
                                        className={`otr-form col-md-12 p-0 d-flex mt-3 ${
                                            isSwitchBandActive ? "justify-content-end" : "justify-content-start"
                                        }`}
                                        ref={node => (filterRefs["system"] = node)}
                                    >
                                        <div className={`selct-otr col-md-12 p-0`}>
                                            <div className="grid-inner d-flex category-selc-drp">
                                                <div
                                                    className={`grid-box position-relative ${
                                                        selectedFilterValuesSystem?.length ? "bg-th-filtered" : ""
                                                    }`}
                                                    onClick={() => handleClickSystemDropdown("dropdown")}
                                                >
                                                    <div className={`dropdown-container ${showSystemDropDown ? "dropdown-open" : ""} `}>
                                                        <div className="dropdown-toggle click-dropdown">
                                                            System
                                                            <span className="close-reg">
                                                                <i className="fas fa-chevron-down" />
                                                            </span>
                                                        </div>
                                                        {showSystemDropDown && (
                                                            <div className={`dropdown-menu p-0 ${showSystemDropDown ? "dropdown-active" : ""}`}>
                                                                <div className="drop-filtr dp-rcm-overflow" onClick={e => e.stopPropagation()}>
                                                                    <div className="col-md-12 p-0 border-bottom pt-1">
                                                                        <span className="dropdown-item build_search_drp">
                                                                            <input
                                                                                type="search"
                                                                                placeholder="Search..."
                                                                                value={searchValueSystem}
                                                                                onChange={e => {
                                                                                    let value = e.target.value;
                                                                                    setSearchValueSystem(prevSearch => {
                                                                                        return value;
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <i
                                                                                className="fas fa-times cursor-pointer cls-close"
                                                                                onClick={() =>
                                                                                    setSearchValueSystem(prevSearch => {
                                                                                        return "";
                                                                                    })
                                                                                }
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-12 p-0 border-bottom pt-1">
                                                                        <div className="dropdown-item select_section_outer">
                                                                            <label className={`container-check ${viewOnly ? "cursor-disabled" : ""}`}>
                                                                                Select all
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={
                                                                                        systemData.length &&
                                                                                        systemDropdown?.length == systemData.length
                                                                                    }
                                                                                    onClick={e => handleSelectAll(e.target.checked, "system")}
                                                                                    disabled={viewOnly}
                                                                                />
                                                                                <span
                                                                                    className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}
                                                                                ></span>
                                                                            </label>
                                                                            <button
                                                                                className={`clear-btn-selection ${viewOnly ? "cursor-disabled" : ""}`}
                                                                                onClick={() => {
                                                                                    setSystemData([]);
                                                                                    setSystemDataName([]);
                                                                                }}
                                                                                disabled={viewOnly}
                                                                            >
                                                                                Clear
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 p-0 slt-ara border-bottom dpr-wide-txt">
                                                                        {systemDropdown
                                                                            ?.filter(fi => systemData?.includes(fi.id))
                                                                            ?.map(data => (
                                                                                <span className="dropdown-item" key={data.id}>
                                                                                    <label
                                                                                        className={`container-check ${
                                                                                            viewOnly ? "cursor-disabled" : ""
                                                                                        }`}
                                                                                    >
                                                                                        <span
                                                                                            className="text-short"
                                                                                            data-tip={
                                                                                                data.name?.length + data?.description?.length > 25
                                                                                                    ? `${data.name} ${
                                                                                                          data.description
                                                                                                              ? `(${data.description})`
                                                                                                              : ""
                                                                                                      }`
                                                                                                    : null
                                                                                            }
                                                                                            data-effect="solid"
                                                                                            data-for="smart-chart-master-filter"
                                                                                            data-place="left"
                                                                                            data-background-color="#007bff"
                                                                                            data-delay-show="500"
                                                                                        >
                                                                                            {data.name}{" "}
                                                                                            {data.description ? `(${data.description})` : ""}
                                                                                        </span>
                                                                                        {data.count ? (
                                                                                            <span className="count-num"> ({data.count})</span>
                                                                                        ) : null}
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={systemData.includes(data.id)}
                                                                                            onChange={e =>
                                                                                                handleSelectDropdown(data.id, "system", data)
                                                                                            }
                                                                                            disabled={viewOnly}
                                                                                        />
                                                                                        <span
                                                                                            className={`checkmark ${
                                                                                                viewOnly ? "cursor-disabled" : ""
                                                                                            }`}
                                                                                        />
                                                                                    </label>
                                                                                </span>
                                                                            ))}
                                                                    </div>
                                                                    {/* {renderFilteredList("system")?.filter(fi => !systemData?.includes(fi.id))
                                                                        ?.length ? (
                                                                        <div className="col-md-12 p-0 slt-ara overflw-ht dpr-wide-txt">
                                                                            {renderFilteredList("system")
                                                                                ?.filter(fi => !systemData?.includes(fi.id))
                                                                                ?.map(data => (
                                                                                    <span className="dropdown-item" key={data.id}>
                                                                                        <label
                                                                                            className={`container-check ${
                                                                                                viewOnly ? "cursor-disabled" : ""
                                                                                            }`}
                                                                                        >
                                                                                            <span
                                                                                                className="text-short"
                                                                                                data-tip={
                                                                                                    data.name?.length + data?.description?.length > 25
                                                                                                        ? `${data.name} ${
                                                                                                              data.description
                                                                                                                  ? `(${data.description})`
                                                                                                                  : ""
                                                                                                          }`
                                                                                                        : null
                                                                                                }
                                                                                                data-effect="solid"
                                                                                                data-for="smart-chart-master-filter"
                                                                                                data-place="left"
                                                                                                data-background-color="#007bff"
                                                                                                data-delay-show="500"
                                                                                            >
                                                                                                {data.trade ? `${data.trade}-` : ""}
                                                                                                {data.name}{" "}
                                                                                                {data.description ? `(${data.description})` : ""}
                                                                                            </span>
                                                                                            {data.count ? (
                                                                                                <span className="count-num"> ({data.count})</span>
                                                                                            ) : null}
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={false}
                                                                                                onChange={e =>
                                                                                                    handleSelectDropdown(data.id, "system", data)
                                                                                                }
                                                                                                disabled={viewOnly}
                                                                                            />
                                                                                            <span
                                                                                                className={`checkmark ${
                                                                                                    viewOnly ? "cursor-disabled" : ""
                                                                                                }`}
                                                                                            />
                                                                                        </label>
                                                                                    </span>
                                                                                ))}
                                                                        </div>
                                                                    ) : (
                                                                        <div className={`col-md-12`}>
                                                                            {renderFilteredList("system")?.filter(fi => !systemData?.includes(fi.id))
                                                                                ?.length === 0
                                                                                ? "No data Found"
                                                                                : ""}
                                                                        </div>
                                                                    )} */}
                                                                    <div className="col-md-12 drp-btn">
                                                                        <button
                                                                            type="button"
                                                                            className={`btn btn-primary ${viewOnly ? "cursor-disabled" : ""}`}
                                                                            onClick={() => handleClickSystemDropdown("submit")}
                                                                            disabled={viewOnly}
                                                                        >
                                                                            ok
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary btnClr ml-2"
                                                                            onClick={() => handleClickSystemDropdown("cancel")}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        ) : null}
                        <div className={`otr-form col-md-12 p-0 d-flex mt-3`} ref={node => (filterRefs["common"] = node)}>
                            <div className={`selct-otr col-md-12 p-0 `}>
                                <div className="grid-inner d-flex category-selc-drp">
                                    <div
                                        className={`grid-box position-relative ${selectedFilterValues?.length ? "bg-th-filtered" : ""}`}
                                        onClick={() => handleClickDropdown(filterLabel?.label, "dropdown")}
                                    >
                                        <div className={`dropdown-container ${showDropDown ? "dropdown-open" : ""}`}>
                                            <div className="dropdown-toggle click-dropdown">
                                                {filterLabel?.label || "-"}
                                                <span className="close-reg">
                                                    <i className="fas fa-chevron-down" />
                                                </span>
                                            </div>
                                            {showDropDown && (
                                                <div className={`dropdown-menu p-0 ${showDropDown ? "dropdown-active" : ""}`}>
                                                    <div className="drop-filtr dp-rcm-overflow" onClick={e => e.stopPropagation()}>
                                                        <div className="col-md-12 p-0 border-bottom pt-1">
                                                            <span className="dropdown-item build_search_drp">
                                                                <input
                                                                    type="search"
                                                                    placeholder="Search..."
                                                                    value={searchValue}
                                                                    onChange={e => {
                                                                        let value = e.target.value;
                                                                        setSearchValue(prevSearch => {
                                                                            return value;
                                                                        });
                                                                    }}
                                                                />
                                                                <i
                                                                    className="fas fa-times cursor-pointer cls-close"
                                                                    onClick={() =>
                                                                        setSearchValue(prevSearch => {
                                                                            return "";
                                                                        })
                                                                    }
                                                                />
                                                            </span>
                                                        </div>
                                                        <div className="col-md-12 p-0 border-bottom pt-1">
                                                            <div className="dropdown-item select_section_outer">
                                                                <label className={`container-check ${viewOnly ? "cursor-disabled" : ""}`}>
                                                                    Select all
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={dataValue.length && dropdowns?.length == dataValue.length}
                                                                        onClick={e => handleSelectAll(e.target.checked, filterLabel?.label)}
                                                                        disabled={viewOnly}
                                                                    />
                                                                    <span className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                </label>
                                                                <button
                                                                    className={`clear-btn-selection ${viewOnly ? "cursor-disabled" : ""}`}
                                                                    onClick={() => {
                                                                        setData([]);
                                                                        setDataName([]);
                                                                    }}
                                                                    disabled={viewOnly}
                                                                >
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 p-0 slt-ara border-bottom dpr-wide-txt">
                                                            {dropdowns
                                                                ?.filter(fi => dataValue?.includes(fi.id))
                                                                ?.map(data => (
                                                                    <span className="dropdown-item" key={data.id}>
                                                                        <label className={`container-check ${viewOnly ? "cursor-disabled" : ""}`}>
                                                                            <span
                                                                                className="text-short"
                                                                                data-tip={
                                                                                    data.name?.length + data?.description?.length > 25
                                                                                        ? `${data.name} ${
                                                                                              data.description ? `(${data.description})` : ""
                                                                                          }`
                                                                                        : null
                                                                                }
                                                                                data-effect="solid"
                                                                                data-for="smart-chart-master-filter"
                                                                                data-place="left"
                                                                                data-background-color="#007bff"
                                                                                data-delay-show="500"
                                                                            >
                                                                                {data.trade ? `${data.trade}-` : ""}
                                                                                {data.name} {data.description ? `(${data.description})` : ""}
                                                                            </span>
                                                                            {data.count ? <span className="count-num"> ({data.count})</span> : null}
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={dataValue.includes(data.id)}
                                                                                onChange={e => handleSelectDropdown(data.id, filterLabel, data)}
                                                                                disabled={viewOnly}
                                                                            />
                                                                            <span className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`} />
                                                                        </label>
                                                                    </span>
                                                                ))}
                                                        </div>
                                                        {renderFilteredList()?.filter(fi => !dataValue?.includes(fi.id))?.length ? (
                                                            <div className="col-md-12 p-0 slt-ara overflw-ht dpr-wide-txt">
                                                                {renderFilteredList()
                                                                    ?.filter(fi => !dataValue?.includes(fi.id))
                                                                    ?.map(data => (
                                                                        <span className="dropdown-item" key={data.id}>
                                                                            <label className={`container-check ${viewOnly ? "cursor-disabled" : ""}`}>
                                                                                <span
                                                                                    className="text-short"
                                                                                    data-tip={
                                                                                        data.name?.length + data?.description?.length > 25
                                                                                            ? `${data.name} ${
                                                                                                  data.description ? `(${data.description})` : ""
                                                                                              }`
                                                                                            : null
                                                                                    }
                                                                                    data-effect="solid"
                                                                                    data-for="smart-chart-master-filter"
                                                                                    data-place="left"
                                                                                    data-background-color="#007bff"
                                                                                    data-delay-show="500"
                                                                                >
                                                                                    {data.trade ? `${data.trade}-` : ""}
                                                                                    {data.name} {data.description ? `(${data.description})` : ""}
                                                                                </span>
                                                                                {data.count ? (
                                                                                    <span className="count-num"> ({data.count})</span>
                                                                                ) : null}
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={false}
                                                                                    onChange={e =>
                                                                                        handleSelectDropdown(data.id, filterLabel?.label, data)
                                                                                    }
                                                                                    disabled={viewOnly}
                                                                                />
                                                                                <span className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`} />
                                                                            </label>
                                                                        </span>
                                                                    ))}
                                                            </div>
                                                        ) : (
                                                            <div className={`col-md-12`}>
                                                                {renderFilteredList()?.filter(fi => !dataValue?.includes(fi.id))?.length === 0
                                                                    ? "No data Found"
                                                                    : ""}
                                                            </div>
                                                        )}
                                                        <div className="col-md-12 drp-btn">
                                                            <button
                                                                type="button"
                                                                className={`btn btn-primary ${viewOnly ? "cursor-disabled" : ""}`}
                                                                onClick={() => handleClickDropdown(filterLabel?.label, "submit")}
                                                                disabled={viewOnly}
                                                            >
                                                                ok
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btnClr ml-2"
                                                                onClick={() => handleClickDropdown("cancel")}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    };

    const renderColumnConfigModal = () => {
        if (!showColumnConfigModal) return null;
        return (
            <Portal
                body={
                    <CAColumnConfigModal
                        selectedElements={selectedElements}
                        onSave={({ selectedColumnKeys, property, template }) => {
                            setSelectedFields(selectedColumnKeys);
                            setSelectedProperty(property);
                            setSelectedTemplate(template);
                            setColumnConfigModal(false);
                        }}
                        onCancel={() => setColumnConfigModal(false)}
                        selectedFields={selectedFields}
                        selectedProperty={selectedProperty}
                        selectedTemplate={selectedTemplate}
                        selectedClient={selectedClient}
                        selectedProject={selectedProject}
                        isEdit={isEdit}
                        isView={viewOnly}
                    />
                }
                onCancel={() => setColumnConfigModal(false)}
            />
        );
    };
    const renderMultiColumnConfigModal = () => {
        if (!showMultiColumnConfigModal) return null;
        return (
            <Portal
                body={
                    <CAColumnConfigModalStepper
                        selectedElements={selectedElements}
                        onSave={({ selectedColumnKeys, property, template, selectedTableConfig }) => {
                            setSelectedFields(selectedColumnKeys);
                            setSelectedProperty(property);
                            setSelectedTemplate(template);
                            setMultiColumnConfigModal(false);
                            setTableConfig(selectedTableConfig);
                        }}
                        onCancel={() => setMultiColumnConfigModal(false)}
                        selectedFields={selectedFields}
                        selectedProperty={selectedProperty}
                        selectedTemplate={selectedTemplate}
                        selectedClient={selectedClient}
                        selectedProject={selectedProject}
                        tableConfig={tableConfig}
                        isEdit={isEdit}
                        filterData={filterData}
                        setFilterData={setFilterData}
                        filterDataName={filterDataName}
                        setFilterDataName={setFilterDataName}
                        getParamsForMasterFilter={getParamsForMultiCombinationFilter}
                        filter={filter}
                        setFilter={setFilter}
                        isView={viewOnly}
                        isSwitchBandActive={isSwitchBandActive}
                        isLegacyExport={isLegacyExport}
                    />
                }
                onCancel={() => setMultiColumnConfigModal(false)}
            />
        );
    };

    const mapConfigToFields = config => {
        if (!config) return [{ name: "", startYear: null, endYear: null, inflation: false }];

        const startIndex = Object.keys(config.break_down_1 || {})?.includes("r_criticality_type") ? 2 : 1;
        if (startIndex === 2) {
            const immediateValue = config?.break_down_1;
            setImmediateData({
                label: immediateValue?.label,
                displayImmediateCost: immediateValue?.r_criticality_type,
                inflation: Object?.keys(immediateValue?.sub_break_down || {})?.includes("label"),
                inflationLabel: immediateValue?.sub_break_down?.label
            });
        }
        const fieldsArray = Object.keys(config || {})
            .filter(key => key.startsWith("break_down_"))
            .filter(key => parseInt(key.split("_")[2]) >= startIndex)
            .map(key => {
                const breakDown = config[key] || {};
                return {
                    label: breakDown.label || "",
                    startYear: { label: breakDown?.years?.[0], value: parseInt(breakDown?.years?.[0]) } || null,
                    endYear:
                        breakDown?.years?.length > 1
                            ? {
                                  label: breakDown?.years?.[breakDown?.years?.length - 1],
                                  value: parseInt(breakDown?.years?.[breakDown?.years?.length - 1])
                              } || null
                            : null,
                    inflation: Object?.keys(breakDown?.sub_break_down || {})?.includes("label"),
                    inflationLabel: breakDown?.sub_break_down?.label
                };
            });

        return fieldsArray.length > 0 ? fieldsArray : [{ name: "", startYear: null, endYear: null, inflation: false, inflationLabel: "" }];
    };
    const addField = () => {
        const lastField = fields[fields.length - 1];
        const newErrors = {};

        if (!lastField.startYear) {
            newErrors[`field-${fields.length - 1}-startYear`] = true;
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(prevErrors => ({
                ...prevErrors,
                ...newErrors
            }));
            return;
        }

        setErrors(prevErrors => {
            const updatedErrors = { ...prevErrors };
            return updatedErrors;
        });

        setFields([
            ...fields,
            {
                label: "",
                startYear: null,
                endYear: null,
                inflation: false,
                inflationLabel: ""
            }
        ]);
    };
    const removeField = index => {
        setFields(fields.filter((_, i) => i !== index));
    };

    const handleFieldChange = (index, key, value) => {
        setFields(prevFields =>
            prevFields.map((field, i) => {
                if (i < index) return field;

                if (i === index) {
                    return {
                        ...field,
                        [key]: value,
                        ...(key === "startYear" ? { endYear: null } : {})
                    };
                }

                return key === "startYear" || key === "endYear" ? { ...field, startYear: null, endYear: null } : field;
            })
        );

        if ((key === "startYear" || key === "label") && value) {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[`field-${index}-${key}`];
                return newErrors;
            });
        }
    };

    const getYearsBetween = (start, end) => {
        if (!start) return [];
        if (!end) return [start];

        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    const handleSaveBreakdownYears = () => {
        const formattedData = {};
        let allYears = new Set();

        if (immediateData?.displayImmediateCost) {
            formattedData["break_down_1"] = {
                r_criticality_type: "Immediate",
                label: immediateData?.label?.trim()
            };
            if (immediateData?.inflation) {
                formattedData["break_down_1"]["sub_break_down"] = { label: immediateData?.inflationLabel?.trim() };
            }
        }

        fields
            ?.filter(field => field?.startYear?.value)
            ?.forEach((field, index) => {
                const key = `break_down_${index + (immediateData?.displayImmediateCost ? 2 : 1)}`;
                const years = getYearsBetween(field.startYear?.value, field.endYear?.value);

                formattedData[key] = {
                    years,
                    label: field.label?.trim()
                };

                if (field?.inflation) {
                    formattedData[key]["sub_break_down"] = { label: field?.inflationLabel?.trim() };
                }
                years.forEach(year => allYears?.add(year));
            });

        if (formattedData?.["break_down_1"] && immediateData?.displayImmediateCost) {
            formattedData["break_down_1"]["years"] = Array.from(allYears).sort();
        }

        return formattedData;
    };

    const getYearOptions = (startYear = years?.[0], yearList = years) => {
        if (!Array.isArray(yearList) || yearList?.length === 0 || isNaN(startYear)) return [];

        return yearList
            .filter(y => y >= startYear)
            .map(y => ({
                label: y?.toString(),
                value: y
            }));
    };
    const getEndYearOptions = startYear => {
        if (!Array.isArray(years) || years?.length === 0 || !startYear) return [];
        return years
            ?.filter(data => data >= startYear)
            ?.map(item => ({
                label: item?.toString(),
                value: item
            }));
    };

    const getLastEndYear = () => {
        const lastYearField = [...fields]
            ?.slice(0, -1)
            ?.reverse()
            ?.find(field => field.endYear?.value || field.startYear?.value);
        return lastYearField ? parseInt(lastYearField.endYear?.value || lastYearField.startYear?.value) + 1 : years?.[0];
    };

    const selectRecommendationElementExportOption = () => {
        setYearBreakdown(false);
        setSelectedElements({ ...selectedElements, column: [] });
    };

    const selectCapitalSpendingYearGroupingOption = () => {
        setYearBreakdown(true);
        if (getDefaultYearBreakdownResponse?.data?.break_down_years) {
            setFields(mapConfigToFields(getDefaultYearBreakdownResponse?.data?.break_down_years));
        } else {
            setFields([
                {
                    label: "",
                    startYear: null,
                    endYear: null,
                    inflation: false,
                    inflationLabel: ""
                }
            ]);
            setImmediateData({
                label: "",
                displayImmediateCost: "",
                inflation: false,
                inflationLabel: ""
            });
        }
    };

    const handleCancelModal = () => {
        const hasFormChanges = initialFormSnapshot.current ? !_.isEqual(initialFormSnapshot.current, getFormSnapshot()) : false;
        if (hasFormChanges && !viewOnly) {
            setCancelConfirmationModal(true);
            return;
        }
        onCancel();
    };

    const renderCancelConfirmationModal = () => {
        if (!cancelConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to clear and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => setCancelConfirmationModal(false)}
                        onYes={onCancel}
                    />
                }
                onCancel={() => setCancelConfirmationModal(false)}
            />
        );
    };

    const renderConfirmationModal = () => {
        if (!confirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to save year breakdown property to the client default export property?"}
                        type="cancel"
                        onNo={() => {
                            handleSaveConfig();
                            setConfirmationModal(false);
                        }}
                        onYes={() => {
                            handleSaveConfig();
                            dispatch(
                                actions?.patchYearBreakdownProperty({
                                    break_down_years: { ...handleSaveBreakdownYears() },
                                    chart_property_id: selectedExportProperty
                                })
                            );
                            setConfirmationModal(false);
                        }}
                        onCloseModal={() => {
                            setConfirmationModal(false);
                        }}
                    />
                }
                onCancel={() => setConfirmationModal(false)}
            />
        );
    };

    const handleMultiSelectClick = type => {
        setSelectedElements(prev => ({
            ...prev,
            [type]: (selectedElemOption?.[type] || [])?.map(e => e.value) || []
        }));
        setMenuOpen({ ...menuOpen, [type]: false });
    };

    const getParamsForMultiCombinationFilter = paramKey => {
        let currentUser = localStorage.getItem("userId") || "";
        const { project_ids, region_ids, site_ids, building_ids, building_type_ids, ...restMfilter } = mfilter;
        const { [paramKey]: omit, ...restFilter } = filterData;
        let params = {
            project_id: entityMfilters?.project_ids ? [...entityMfilters.project_ids] : null,
            region_id: entityMfilters?.region_ids ? [...entityMfilters.region_ids] : null,
            site_id: entityMfilters?.site_ids ? [...entityMfilters.site_ids] : null,
            building_id: entityMfilters?.building_ids ? [...entityMfilters.building_ids] : null,
            building_type_id: entityMfilters?.building_types ? [...entityMfilters.building_types] : null,
            user_id: currentUser,
            ...restMfilter,
            ...restFilter
        };

        return params;
    };

    const toggleLegacyExport = () => {
        if (selectedFields && Object.keys(selectedFields).length) {
            setLegacyExportConfirmationModal(true);
        } else {
            setLegacyExport(!isLegacyExport);
        }
    };

    const renderLegacyExportConfirmationModal = () => {
        if (!legacyExportConfirmationModal) return null;
        const heading = isLegacyExport
            ? "Disabling legacy export will erase your current field settings. Are you sure?"
            : "Enabling legacy export will erase your current field settings. Are you sure?";

        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={heading}
                        type="cancel"
                        onNo={() => {
                            setLegacyExportConfirmationModal(false);
                        }}
                        onYes={() => {
                            setSelectedFields({});
                            setLegacyExport(!isLegacyExport);
                            setLegacyExportConfirmationModal(false);
                        }}
                    />
                }
                onCancel={() => setLegacyExportConfirmationModal(false)}
            />
        );
    };

    const isSingleLineTradeOrSystem =
        selectedElements.line.length === 1 && ["trade", "system", "subsystem"].some(v => selectedElements.line[0] === v);

    const isRecomTypeColumn = selectedElements.column.length === 1 && selectedElements.column[0] === "recomtype";

    const showLegacyExport = isSingleLineTradeOrSystem && isRecomTypeColumn;

    return (
        <div
            className="modal modal-region smart-chart-popup smart-dtl-pop add-image-modal img-pop-sing add-ca-band"
            id="modalId"
            tabIndex="-1"
            style={{ display: "block" }}
        >
            {renderColumnConfigModal()}
            {renderMultiColumnConfigModal()}
            {showAdditionalExportOptionsModal && (
                <AdditionalExportOptionsModal
                    onCancel={() => setShowAdditionalExportOptionsModal(false)}
                    yearBreakdown={yearBreakdown}
                    isSwitchBandActive={isSwitchBandActive}
                    onSave={isYearBreakdownSelected => {
                        if (isYearBreakdownSelected) {
                            selectCapitalSpendingYearGroupingOption();
                        } else {
                            selectRecommendationElementExportOption();
                        }
                        setShowAdditionalExportOptionsModal(false);
                    }}
                    viewOnly={viewOnly}
                />
            )}
            <Draggable handle=".draggable" cancel=".not-draggable">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <div className="txt-hed">Configure Comparative Analysis</div>
                            </h5>
                            <button type="button" className="close not-draggable" onClick={handleCancelModal}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body region-otr p-0 overflow-inherit">
                            <div className="img-repr col-12 d-flex">
                                <div className="img-rep-otr d-flex flex-wrap col-6 line-element">
                                    <div className="img-rep-item col-md-12">
                                        <div className="cont-sec">
                                            <div className="img-sec">
                                                <img src="/img/ca-band-line.svg" />
                                            </div>
                                            <h3>Line Element</h3>
                                        </div>
                                    </div>
                                    <div className="otr-form col-md-12 p-0 d-flex mt-3">
                                        <div className="selct-otr col-12 p-0 cmp-top">
                                            <label>{isSwitchBandActive ? "Geo Hierarchy" : "Recommendation Elements"}</label>
                                            <ReactSelect
                                                className={showErrorBorder && !selectedElements.line?.length ? "error-border" : ""}
                                                isMulti={false}
                                                options={options}
                                                styles={{
                                                    menu: provided => ({
                                                        ...provided,
                                                        position: "relative"
                                                    })
                                                }}
                                                onChange={(selected, actionMeta) => handlePendingSelectElements("line", selected, actionMeta)}
                                                isDisabled={viewOnly}
                                                classNamePrefix="react-select"
                                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                                menuIsOpen={menuOpen.line}
                                                onMenuOpen={() => setMenuOpen(prevMenuOpen => ({ ...prevMenuOpen, line: true }))}
                                                onMenuClose={() => handleSelectMenuClose("line")}
                                                menuPlacement="auto"
                                                value={selectedElemOption?.line}
                                                hideSelectedOptions={false}
                                                isClearable={false}
                                                isSearchable
                                                closeMenuOnSelect={false}
                                                onApplySelection={() => handleApplySelectElements("line")}
                                                onCancelSelection={() => handleCancelSelectElements("line")}
                                            />
                                        </div>
                                        <div
                                            className={`img-swap cursor-pointer ${viewOnly ? "cursor-disabled" : ""}`}
                                            onClick={() => !viewOnly && switchBandElements()}
                                        >
                                            <img src="/img/swap_02.svg" alt="" />
                                        </div>
                                    </div>
                                    {selectedElements.line?.length === 1 &&
                                        selectedElements.column?.length === 1 &&
                                        [...CA_GEO_HIERARCHY_ELEMENTS, ...CA_RECOMMENDATION_ELEMENTS].find(
                                            item => item.key === selectedElements.line[0]
                                        )?.breakdowns?.length && (
                                            <div class="otr-form col-md-12 p-0 d-flex mt-3 justify-content-start">
                                                <div class="input-txt col-md-12 p-0">
                                                    <label>Choose Breakdown Summary</label>
                                                    <div className="d-flex">
                                                        {[...CA_GEO_HIERARCHY_ELEMENTS, ...CA_RECOMMENDATION_ELEMENTS]
                                                            .find(item => item.key === selectedElements.line[0])
                                                            ?.breakdowns.map(item => (
                                                                <div class="img-sq-box seting-type checkbox-container check-field mt-0 mr-2">
                                                                    <label
                                                                        class={`container-checkbox cursor-hand m-0 ${
                                                                            viewOnly ? "cursor-disabled" : ""
                                                                        }`}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedBreakdowns[item.key]}
                                                                            name={item.key}
                                                                            onChange={handleSelectBreakdown}
                                                                            disabled={viewOnly}
                                                                        />
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    {item.label}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    {!isSwitchBandActive &&
                                        selectedElements?.line?.length === 1 &&
                                        CA_RECOMMENDATION_ELEMENTS.find(item => item.key === selectedElements.line[0])?.hasFilter && (
                                            <div className="input-txt mt-3 col-md-12 p-0">
                                                <label>Filters</label>
                                            </div>
                                        )}
                                    {!isSwitchBandActive && selectedElemOption?.line?.length === 1 && renderFilters("line")}
                                </div>
                                <div className="img-rep-otr d-flex flex-wrap col-6 column-element">
                                    <div className="img-rep-item col-md-12">
                                        <div className="cont-sec">
                                            <div className="img-sec">
                                                <img src="/img/ca-band-column.svg" />
                                            </div>
                                            <h3>Column Element</h3>
                                        </div>
                                    </div>
                                    <div className="otr-form col-md-12 p-0 d-flex mt-2">
                                        <div className="selct-otr col-12 p-0">
                                            <div className="otr-form col-md-12 p-0 d-flex mb-2">
                                                <button
                                                    type="button"
                                                    className="btn-colm-blue ca-additional-export-options-btn"
                                                    onClick={() => setShowAdditionalExportOptionsModal(true)}
                                                >
                                                    Additional Export Options
                                                </button>
                                            </div>
                                            {!yearBreakdown ? <label>{isSwitchBandActive ? "Default Export" : "Geo Hierarchy"}</label> : null}
                                            {yearBreakdown ? (
                                                <>
                                                    <div className="form-check mb-3 pl-0">
                                                        <div className="wrapper-check-main">
                                                            <label
                                                                className={`container-check-wrap ${viewOnly ? "cursor-disabled" : ""}`}
                                                                htmlFor="immediate-costs-summary-checkbox"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={immediateData?.displayImmediateCost || false}
                                                                    onChange={() =>
                                                                        setImmediateData({
                                                                            ...immediateData,
                                                                            inflation: false,
                                                                            inflationLabel: "",
                                                                            displayImmediateCost: !immediateData?.displayImmediateCost
                                                                        })
                                                                    }
                                                                    id="immediate-costs-summary-checkbox"
                                                                    className={`form-check-input ${viewOnly ? "cursor-disabled" : ""}`}
                                                                    disabled={viewOnly}
                                                                />
                                                                <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                Display Immediate Costs Summary
                                                            </label>
                                                        </div>
                                                        {immediateData?.displayImmediateCost && (
                                                            <label className="mt-2 col-md-12 inp-wrap p-0">
                                                                Immediate Label*
                                                                <input
                                                                    type="text"
                                                                    className={`form-control mt-2 ${
                                                                        errors[`field-immediate-label`] ? "error-border" : ""
                                                                    }`}
                                                                    value={immediateData.label || ""}
                                                                    onChange={e =>
                                                                        setImmediateData({
                                                                            ...immediateData,
                                                                            label: e.target?.value
                                                                        })
                                                                    }
                                                                    disabled={viewOnly}
                                                                />
                                                            </label>
                                                        )}
                                                        {immediateData?.displayImmediateCost && (
                                                            <label
                                                                className={`container-check-wrap ${viewOnly ? "cursor-disabled" : ""}`}
                                                                htmlFor="immediate-costs-checkbox"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={immediateData?.inflation}
                                                                    onChange={() => {
                                                                        setImmediateData({
                                                                            ...immediateData,
                                                                            inflation: !immediateData?.inflation
                                                                        });
                                                                    }}
                                                                    id="immediate-costs-checkbox"
                                                                    className={`form-check-input ${viewOnly ? "cursor-disabled" : ""}`}
                                                                    disabled={viewOnly}
                                                                />
                                                                <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                Inflation
                                                            </label>
                                                        )}
                                                        {immediateData?.displayImmediateCost && immediateData?.inflation && (
                                                            <label className="form-label col-md-12 inp-wrap p-0">
                                                                Inflation Label*
                                                                <input
                                                                    type="text"
                                                                    className={`form-control mb-2 ${
                                                                        errors?.[`field-immediate-inflation`] ? "error-border" : ""
                                                                    }`}
                                                                    value={immediateData?.inflationLabel || ""}
                                                                    onChange={e =>
                                                                        setImmediateData({
                                                                            ...immediateData,
                                                                            inflationLabel: e.target?.value
                                                                        })
                                                                    }
                                                                    disabled={viewOnly}
                                                                />
                                                            </label>
                                                        )}
                                                    </div>

                                                    <div className="dynamic-fields-container">
                                                        {fields?.map((field, index) => (
                                                            <div key={index} className="mb-3 wrapper-box-main">
                                                                <div class="col-md-12 pl-0">
                                                                    <label className="col-md-12 p-0 inp-wrap">Year Breakdown Label*</label>
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control ${
                                                                            errors?.[`field-${index}-label`] ? "error-border" : ""
                                                                        }`}
                                                                        value={field?.label}
                                                                        onChange={e => handleFieldChange(index, "label", e?.target?.value)}
                                                                        disabled={viewOnly}
                                                                        onKeyDown={e => {
                                                                            if (e.key === "Enter") {
                                                                                handleFieldChange(index, "label", e?.target?.value?.trim());
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="col-md-12 wrapper-bx-dyn pr-0 d-flex pl-0">
                                                                    <div className="col-md-4 pl-0 dyn-fld start-wrap">
                                                                        <ReactSelect
                                                                            options={getYearOptions(
                                                                                field.startYear?.value
                                                                                    ? index === 0
                                                                                        ? years?.[0]
                                                                                        : fields?.[index - 1]?.endYear?.value
                                                                                          ? fields?.[index - 1]?.endYear?.value + 1
                                                                                          : fields?.[index - 1]?.startYear?.value + 1
                                                                                    : getLastEndYear()
                                                                            )}
                                                                            value={field?.startYear}
                                                                            onChange={selected => handleFieldChange(index, "startYear", selected)}
                                                                            isDisabled={viewOnly || index < fields?.length - 1}
                                                                            placeholder="Start Year*"
                                                                            className={errors?.[`field-${index}-startYear`] ? "error-border" : ""}
                                                                            isClearable
                                                                            menuPlacement="auto"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-4 pl-0 dyn-fld end-wrap">
                                                                        <ReactSelect
                                                                            options={getEndYearOptions(field?.startYear?.value)}
                                                                            value={field?.endYear}
                                                                            onChange={selected => handleFieldChange(index, "endYear", selected)}
                                                                            isDisabled={viewOnly || index < fields?.length - 1}
                                                                            placeholder="End Year"
                                                                            isClearable
                                                                            menuPlacement="auto"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 pl-0 dyn-fld inf-wrap">
                                                                        <label
                                                                            className={`container-check-wrap ${viewOnly ? "cursor-disabled" : ""}`}
                                                                            htmlFor={`immediate-costs-checkbox ${[index]}`}
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={field?.inflation || false}
                                                                                id={`immediate-costs-checkbox ${[index]}`}
                                                                                className={`form-check-input ${viewOnly ? "cursor-disabled" : ""}`}
                                                                                disabled={viewOnly}
                                                                                onChange={e => {
                                                                                    handleFieldChange(index, "inflation", e?.target?.checked);
                                                                                }}
                                                                            />
                                                                            <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                                            Inflation
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-1 btn-minus-wrap">
                                                                        {fields.length > 1 && (
                                                                            <button
                                                                                className="btn btn-danger btn-minus"
                                                                                onClick={() => removeField(index)}
                                                                                disabled={viewOnly}
                                                                            >
                                                                                -
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {field.inflation && (
                                                                    <div className="col-md-12 mt-2 p-0">
                                                                        <label> Inflation Label*</label>
                                                                        <input
                                                                            type="text"
                                                                            className={`form-control ${viewOnly ? "cursor-disabled" : ""} ${
                                                                                errors[`field-${index}-inflation`] ? "error-border" : ""
                                                                            }`}
                                                                            value={field.inflationLabel || ""}
                                                                            onChange={e => handleFieldChange(index, "inflationLabel", e.target.value)}
                                                                            disabled={viewOnly}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="btn-plus-wrap">
                                                        <button
                                                            type="button"
                                                            className="btn btn-success me-2 btn-plus"
                                                            onClick={addField}
                                                            disabled={viewOnly}
                                                        >
                                                            +
                                                        </button>
                                                    </div>
                                                </>
                                            ) : (
                                                <ReactSelect
                                                    className={showErrorBorder && !selectedElements.column?.length ? "error-border" : ""}
                                                    isMulti={isSwitchBandActive}
                                                    options={selectOptions}
                                                    styles={{
                                                        menu: provided => ({
                                                            ...provided,
                                                            position: "relative"
                                                        })
                                                    }}
                                                    onChange={(selected, actionMeta) => handlePendingSelectElements("column", selected, actionMeta)}
                                                    isDisabled={viewOnly}
                                                    classNamePrefix="react-select"
                                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                                    menuIsOpen={menuOpen.column}
                                                    onMenuOpen={() => setMenuOpen(prevMenuOpen => ({ ...prevMenuOpen, column: true }))}
                                                    onMenuClose={() => handleSelectMenuClose("column")}
                                                    menuPlacement="auto"
                                                    value={selectedElemOption?.column}
                                                    hideSelectedOptions={false}
                                                    isClearable={false}
                                                    isSearchable
                                                    closeMenuOnSelect={false}
                                                    isOptionDisabled={option => option.isDisabled}
                                                    onApplySelection={() => handleApplySelectElements("column")}
                                                    onCancelSelection={() => handleCancelSelectElements("column")}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    {isSwitchBandActive &&
                                        !yearBreakdown &&
                                        selectedElements?.column?.length === 1 &&
                                        CA_RECOMMENDATION_ELEMENTS.find(item => item.key === selectedElements.column[0])?.hasFilter && (
                                            <div className="input-txt mt-3 col-md-12 p-0">
                                                <label className="mb-0">Filters</label>
                                            </div>
                                        )}
                                    {isSwitchBandActive && !yearBreakdown && selectedElements?.column?.length === 1 && renderFilters("column")}

                                    {(selectedElements.column.includes("recommendations") || selectedElements.column.includes("asset")) &&
                                        selectedElements.column?.length === 1 &&
                                        isExcelExport && (
                                            <div className=" input-txt mt-3">
                                                <div class="img-sq-box seting-type checkbox-container check-field mt-0 mr-2">
                                                    <label class="container-checkbox cursor-hand m-0">
                                                        <input
                                                            type="checkbox"
                                                            checked={pivotTable}
                                                            onChange={() => setPivotTable(!pivotTable)}
                                                            disabled={viewOnly}
                                                        />
                                                        <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                    </label>
                                                    Enable Pivot Table
                                                </div>
                                            </div>
                                        )}
                                    {showLegacyExport && (
                                        <div className=" input-txt mt-3">
                                            <div class="img-sq-box seting-type checkbox-container check-field mt-0 mr-2">
                                                <label class="container-checkbox cursor-hand m-0">
                                                    <input
                                                        type="checkbox"
                                                        checked={isLegacyExport}
                                                        onChange={toggleLegacyExport}
                                                        disabled={viewOnly}
                                                    />
                                                    <span class={`checkmark ${viewOnly ? "cursor-disabled" : ""}`}></span>
                                                </label>
                                                Legacy Export
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {selectedElements?.line?.length === 1 &&
                                selectedElements?.column?.length === 1 &&
                                (selectedElements.column.includes("recommendations") || selectedElements.column.includes("asset")) ? (
                                    <div className={`otr-form col-md-6 ml-auto mr-auto p-0 d-flex ${columnMenuIsOpen ? "mt-2" : "mt-5"}`}>
                                        <button className="btn-colm-blue" onClick={() => setColumnConfigModal(true)}>
                                            <span className="edit-icn-bx">
                                                <i className="fas fa-arrow-right mr-2"></i>Select Columns
                                            </span>
                                        </button>
                                    </div>
                                ) : selectedElements?.line?.length === 1 &&
                                  (selectedElements?.column?.length > 1 ||
                                      (selectedElements.column.length === 1 && selectedElements.column.includes("recomtype"))) ? (
                                    <div className={`otr-form col-md-6 ml-auto mr-auto p-0 d-flex ${columnMenuIsOpen ? "mt-2" : "mt-5"}`}>
                                        <button className="btn-colm-blue" onClick={() => setMultiColumnConfigModal(true)}>
                                            <span className="edit-icn-bx">
                                                <i className="fas fa-arrow-right mr-2"></i>Filter/Select Columns
                                            </span>
                                        </button>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        {!viewOnly && (
                            <div className="modal-footer">
                                <div className="footer-otr col-12">
                                    {Object.values(errors || {})?.length ? (
                                        Object.values(errors || {})?.some(error => typeof error === "string" && error?.includes("Duplicate")) ? (
                                            <div className="errorMessage">Label must be unique</div>
                                        ) : (
                                            <div className="errorMessage">{`*Required ${
                                                Object.values(errors || {})?.length > 1 ? "fields are" : "field is"
                                            } missing`}</div>
                                        )
                                    ) : null}
                                    <div className="btn-otrr">
                                        <button
                                            type="button"
                                            className="btn-img-rpt mr-2"
                                            onClick={() => {
                                                if (
                                                    yearBreakdown &&
                                                    fields?.[0]?.label &&
                                                    validate() &&
                                                    !_.isEqual(
                                                        getDefaultYearBreakdownResponse?.data?.break_down_years || {},
                                                        handleSaveBreakdownYears() || {}
                                                    )
                                                ) {
                                                    setConfirmationModal(true);
                                                } else handleSaveConfig();
                                            }}
                                        >
                                            {isEdit ? "Update" : "Save"}
                                        </button>
                                        <button type="button" className="btn-cancel" onClick={handleCancelModal}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Draggable>
            {renderConfirmationModal()}
            {renderLegacyExportConfirmationModal()}
            {renderCancelConfirmationModal()}
        </div>
    );
};

const CustomOption = ({ innerProps, isSelected, label, innerRef, isDisabled }) => {
    const { onMouseDown, ...rest } = innerProps;

    return (
        <div ref={innerRef} {...rest} className={`d-flex list-react-menu ${isDisabled ? "cursor-disabled" : "cursor-hand"}`}>
            <label className={`container-check ${isDisabled ? "cursor-disabled" : "cursor-hand"}`}>
                <span className={`fake-checkbox ${isSelected ? "checked" : ""}`}></span>
                <span className="option-label">{label}</span>
            </label>
        </div>
    );
};

const CustomMenuList = props => {
    const listRef = useRef(null);
    const { onApplySelection, onCancelSelection, isDisabled } = props.selectProps;
    const handleMenuButtonMouseDown = (e, callback) => {
        e.preventDefault();
        e.stopPropagation();
        callback();
    };

    useEffect(() => {
        if (listRef.current) {
            listRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    }, []);

    return (
        <>
            <components.MenuList {...props} innerRef={listRef}>
                {props.children}
            </components.MenuList>
            <div className="col-md-12 drp-btn ca-element-select-actions">
                <button
                    type="button"
                    className={`btn btn-primary btnRgion ${isDisabled ? "cursor-disabled" : ""}`}
                    onMouseDown={e => handleMenuButtonMouseDown(e, onApplySelection)}
                    disabled={isDisabled}
                >
                    OK
                </button>
                <button type="button" className="btn btn-primary btnClr ml-2" onMouseDown={e => handleMenuButtonMouseDown(e, onCancelSelection)}>
                    Cancel
                </button>
            </div>
        </>
    );
};
export default AddCAbandModal;
